import {Module} from "@/modules";
import NegotiationIndex from "./pages/Index.vue";
import NegotiationShow from "./pages/Show.vue";
import {Negotiation} from "@/modules/diplomacy/entity";
import {NegotiationCloser} from "@/modules/diplomacy/services/NegotiationCloser";
import {NegotiationComponentManager} from "@/modules/diplomacy/services/NegotiationComponentManager";
import messages from "./resources/messages";
import {NegotiationEvaluator} from "@/modules/diplomacy/services/NegotiationEvaluator";

export class DiplomacyModule extends Module {
  messages = messages;
  eventSubscribers = [];

  public entities = [
    Negotiation,
  ];

  routes = [{
    path: '/negotiations',
    name: 'negotiations.index',
    component: NegotiationIndex,
  }, {
    path: '/negotiations/:id',
    name: 'negotiations.show',
    component: NegotiationShow,
  }];

  protected register() {
    super.register();

    this.app.bind<NegotiationComponentManager>(NegotiationComponentManager).to(NegotiationComponentManager).inSingletonScope();
    this.app.bind<NegotiationCloser>(NegotiationCloser).to(NegotiationCloser);
    this.app.bind<NegotiationEvaluator>(NegotiationEvaluator).to(NegotiationEvaluator).inSingletonScope();
  }

  boot() {
    super.boot();
  }
}